<sc-modal>
  <div class="flex justify-between mb-6">
    <h3 class="text-mobileH3 tablet:text-tabletH3 desktop:text-desktopH3 font-headline">
      {{ 'components.replaceSimcardSettings.areYouSureEsim' | scTranslate | async }}
    </h3>
    <sc-button variant="icon" [padding]="false" (click)="close()">
      <sc-svg name="cross" size="w-8 h-8"></sc-svg>
    </sc-button>
  </div>
  <div class="font-semibold mb-1">
    {{ 'components.replaceSimcardSettings.paragraphTitleEsim' | scTranslate | async }}
  </div>
  <p class="mb-6">
    {{ 'components.replaceSimcardSettings.textEsim' | scTranslate | async }}
  </p>
  <p class="mb-6">
    {{ 'components.replaceSimcardSettings.additionalInfoEsim' | scTranslate | async }}
  </p>
  <sc-modal-footer>
    <div class="grid grid-cols-2 gap-x-1.5">
      <sc-button variant="alternate" (click)="close()">
        <span>
          {{ 'shared.cancel' | scTranslate | async }}
        </span>
      </sc-button>
      <sc-button variant="primary" [padding]="false" (click)="close(true)">
        <span>
          {{ 'components.replaceSimcardSettings.confirmEsim' | scTranslate | async }}
        </span>
      </sc-button>
    </div>
  </sc-modal-footer>
</sc-modal>
